import { useForm, FormProvider, Controller, useWatch } from "react-hook-form";
import { AutomationWizardStepProps } from "../../../AutomationsUtils";
import PageWizardFormWrapper from "../../../../Forms/FormWizard/FormWizardFormWrapper";
import PageFormWidget from "../../../../Forms/FormWizard/PageFormRenderer/PageFormWidget/PageFormWidget";
import PageFormButtons from "../../../../Forms/FormWizard/PageFormRenderer/PageFormButtons/PageFormButtons";
import FilterProvider from "../../../../AppView/FilterManagement/FilterProvider/FilterProvider";
import { filterEntityEnum } from "../../../../AppView/FilterManagement/filterEntity";
import ScopeProvider from "../../../../AppView/ScopeManagement/ScopeProvider/ScopeProvider";
import FilterAndScopeInputs from "../../FilterAndScopeInputs/FilterAndScopeInputs";
import { TextInput, REQUIRED_ERROR_MESSAGE } from "@SeemplicityDev/shared";
import "./FindingsStep.scss";

const FindingsStep: React.FC<AutomationWizardStepProps> = ({
  defaultValues,
  onValidate = () => {},
  isSummary = false,
}) => {
  const methods = useForm({
    mode: "all",
    values: defaultValues,
  });
  const { handleSubmit, control, getValues } = methods;
  const filter = useWatch({ control, name: "filter" });
  const scope = useWatch({ control, name: "scope" });

  return (
    <FormProvider {...methods}>
      <PageWizardFormWrapper
        handleSubmit={handleSubmit}
        onSubmit={onValidate}
        getValues={getValues}
      >
        <PageFormWidget isSummary={isSummary}>
          <div
            className={`views-findings-step-container ${isSummary ? "is-summary" : ""}`}
            data-testid="views-findings-step-container"
          >
            <FilterProvider filtersEntity={filterEntityEnum.REMEDIATION_ITEM}>
              <ScopeProvider>
                <FilterAndScopeInputs isSummary={isSummary} />
              </ScopeProvider>
            </FilterProvider>
            <Controller
              name="name"
              control={control}
              rules={{ required: REQUIRED_ERROR_MESSAGE }}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { error },
              }) => {
                return (
                  <TextInput
                    label="Name"
                    viewMode={isSummary}
                    labelTop
                    required
                    data-testid="name-input"
                    name="name"
                    placeholder="Select Name"
                    error={error}
                    onChange={onChange}
                    value={value}
                    onBlur={onBlur}
                  />
                );
              }}
            />
          </div>
        </PageFormWidget>
        {!isSummary && (
          <PageFormButtons
            data-testid={"views-form"}
            nextButtonDisabled={!filter || !scope}
          />
        )}
      </PageWizardFormWrapper>
    </FormProvider>
  );
};

export default FindingsStep;
